import { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useLang } from "@/context/LangContext";
import { useDict } from "@/i18n/dict";
import { AUTH } from "@/constants/testIds";

export default function ForgotPasswordPage() {
  const { lang } = useLang();
  const t = useDict(lang);
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.forgotPassword(email, lang);
      setSent(true);
    } catch {
      // Always show generic confirmation regardless of backend response,
      // to avoid revealing whether the email exists.
      setSent(true);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-6 pt-20 pb-24">
      <p className="eyebrow mb-4">№ 04</p>
      <h1 className="font-serif-display text-5xl mb-2">{t.auth.forgotTitle}</h1>
      <p className="text-[color:var(--ink-2)] mb-10">{t.auth.forgotIntro}</p>

      {sent ? (
        <p data-testid={AUTH.forgotSuccess} className="text-sm text-[color:var(--ink-2)] mb-8">
          {t.auth.forgotSent}
        </p>
      ) : (
        <form onSubmit={submit} className="space-y-6">
          <div>
            <label className="label-line">{t.auth.email}</label>
            <input
              data-testid={AUTH.forgotEmail}
              required
              type="email"
              className="input-line"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <button data-testid={AUTH.forgotSubmit} disabled={busy} className="btn-navy w-full justify-center">
            {busy ? "..." : t.auth.forgotCta}
          </button>
        </form>
      )}

      <div className="mt-10">
        <Link to="/auth" className="text-xs tracking-[0.22em] uppercase underline text-[color:var(--ink-2)]">
          {t.auth.backToLogin}
        </Link>
      </div>
    </div>
  );
}
